import { TableColumn } from '../../table/interfaces/table';
import {
  USAGE_SUMMARY_PIPELINE_TYPE_DISPLAY_DATA,
  UsageSummary,
  UsageSummaryBillingCycle
} from './interface';
import { UsageSummaryCount } from './UsageSummaryCount';
import { UsageSummaryDuration } from './UsageSummaryDuration';
import { UsageSummaryHeaderCell } from './UsageSummaryHeaderCell';
import { UsageSummaryPipelineCell } from './UsageSummaryPipelineCell';

export function getUsageSummaryColumns(
  activeCount: number,
  totalCount: number,
  headerStats: UsageSummaryBillingCycle[],
  isMultiRegion: boolean,
  isH20Enabled: boolean
): TableColumn<UsageSummary>[] {
  return [
    {
      id: 'id',
      field: 'id',
      headerName: '',
      renderHeaderCell: () => (
        <UsageSummaryHeaderCell
          label='Pipelines'
          description={`${activeCount} active out of ${totalCount}`}
        />
      ),
      width: 250,
      minWidth: 250,
      isFlexible: true,
      renderCell: params => <UsageSummaryPipelineCell summary={params.row.data} />
    },
    ...(isH20Enabled
      ? ([
          {
            id: 'id',
            field: 'id',
            headerName: '',
            renderHeaderCell: () => <UsageSummaryHeaderCell label='Engine' />,
            width: 60,
            renderCell: params => (
              <div className='text-body-3'>
                {USAGE_SUMMARY_PIPELINE_TYPE_DISPLAY_DATA[params.row.data.pipelineType]}
              </div>
            ),
            canSort: true,
            sortKey: 'pipelineType'
          }
        ] as TableColumn<UsageSummary>[])
      : []),
    ...(isMultiRegion
      ? ([
          {
            id: 'region',
            field: 'region',
            headerName: '',
            renderHeaderCell: () => <UsageSummaryHeaderCell label='Region' />,
            width: 70,
            renderCell: params => <div className='text-body-3'>{params.row.data.region}</div>,
            canSort: true,
            sortKey: 'region'
          }
        ] as TableColumn<UsageSummary>[])
      : []),
    ...headerStats.map(
      (stat, index) =>
        ({
          id: 'id',
          field: 'id',
          headerName: '',
          renderHeaderCell: () => (
            <UsageSummaryHeaderCell
              label={
                <UsageSummaryDuration
                  label={stat.label}
                  startTime={stat.startTime}
                  endTime={stat.endTime}
                />
              }
              description={<UsageSummaryCount count={stat.count || 0} />}
            />
          ),
          width: 100,
          justifyEnd: false,
          renderCell: params => (
            <div className='text-body-3'>
              <UsageSummaryCount count={params.row.data.events[index]} />
            </div>
          ),
          canSort: true,
          sortKey: `events-${index}`
        }) as TableColumn<UsageSummary>
    )
  ];
}
